import Typography from '@mui/material/Typography';

const Logout = ({ onLogout }) => {
	queueMicrotask(() => {
        window.location.href = '/'
    })
    onLogout()
	return <Typography>Logging out</Typography>;
};

export default Logout;
